module.exports = __webpack_public_path__ + "templates/account.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/plugins/login/templates/account.html
// module id = E58l
// module chunks = 1